import { FC, useMemo } from 'react'

import SafetyCaseActionFormFields from './safety-case-action-form-fields'

import { ISafetyCaseActionFormProps } from './safety-case-action-form-types'

const SafetyCaseActionForm: FC<ISafetyCaseActionFormProps> = props => {
  const { formName, handleSubmit, submitting, disabled, form, initialValues } = props

  const isDisabled = useMemo(() => submitting || disabled, [submitting, disabled])

  return (
    <form onSubmit={handleSubmit} id={formName}>
      <SafetyCaseActionFormFields disabled={isDisabled} form={form} initialValues={initialValues} />
    </form>
  )
}

export default SafetyCaseActionForm
